$(document).ready(function () {
	var winWT = $(window).innerWidth();

	var bannerTypeThumbArr = $('.banner_type').find('.type');
	var bannerBtnArr = $('#banner').find('.button');
	var bannerVideoArr = $('#banner').find('video');
	console.log(bannerVideoArr.length);
	bannerTypeThumbArr.unbind('click');
	bannerTypeThumbArr.each(function (index) {
		$(this).on({
			mouseenter: function () {
				//$('video').trigger('pause');
				if(index < bannerVideoArr.length){
					console.log('yes');
					$('video').get(index).currentTime = 0;
					$('video').get(index).play();
				}
				$('.banner_con').slick('slickGoTo', index);
				if (bannerTypeThumbArr.length != 0) {
					$('.banner_con').slick('slickPause');
				}
			},
			mouseleave: function(){
				$('.banner_con').slick('slickPlay');
			}
		});
	});

	$('.banner_con').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		bannerTypeThumbArr.removeClass('active');
		$(bannerTypeThumbArr[nextSlide]).addClass('active');
		bannerBtnArr.css({display:'none'});
		$(bannerBtnArr[nextSlide]).css({display:'block'});
		$('video').get(0).currentTime = 0;
	});

	$('.banner_con').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		autoplay: false,
		speed: 800,
        autoplaySpeed: 6000,
	});

	var bannerHT = $('#banner .mob_video').innerHeight();
	var setBannerHT = function(){
		winWT = $(window).innerWidth();
		bannerHT = $('#banner .mob_video').innerHeight();
		console.log(winWT, 'wt');
		if(winWT <= 1023){
			console.log(bannerHT, 'ht');
			$('#banner').css({height:bannerHT+'px', overflow:'hidden'});
		}
		
	}
	//setBannerHT();
	/**********************************************************************************/
	/**********************************************************************************/

	/* $('.founders_hld').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		autoplay: false,
		infinite: false,
		speed: 400,
		responsive: [
			{
				breakpoint: 10000,
				settings: "unslick"
			},
			{
				breakpoint: 375,
				settings: {
					slidesToShow: 1,
					dots: false,
					centerMode: true,
					centerPadding: '60px',
				}
			},
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
					dots: false,
					centerMode: true,
					centerPadding: '80px',
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					dots: false,
					centerMode: true,
					centerPadding: '160px',
				}
			}
		]
	}); */

	/**********************************************************************************/
	/**********************************************************************************/

	$('.why_choose_ecofy .tiles_ecofy').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		autoplay: false,
		infinite: false,
		speed: 400,
		responsive: [
			{
				breakpoint: 10000,
				settings: "unslick"
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	/**********************************************************************************/
	/**********************************************************************************/

	$('.product_blurb_hld').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		autoplay: false,
		infinite: false,
		speed: 400,
		responsive: [
			{
				breakpoint: 10000,
				settings: "unslick"
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				}
			}
		]
	});

	function founderOnMouseMove() {
		winWT = $(window).innerWidth();
		if (winWT >= 1024) {
			$('.founders').on('mousemove', function (event) {
				var x = (event.clientX / $(window).width() - 0.5);
				var y = (event.clientY / $(window).height());

				gsap.to('.founders_hld', {
					duration: 0.6,
					x: 70 * x,
					y: 5 * y,
					ease: Power1.easeOut,
					transformPerspective: 500,
					transformOrigin: "center"
				}, 'movement');
				/* gsap.to('.founders .ecofy img', {
					duration: 0.3,
					x: 20 * x,
					y: 10 * y,
					ease: Power1.easeOut,
					transformPerspective: 100,
					transformOrigin: "center"
				}, 'movement'); */

			});
		}
	}
	founderOnMouseMove();

	$(window).resize(function () {
		winWT = $(window).innerWidth();
		bannerHT = $('#banner .mob_video').innerHeight();
		founderOnMouseMove();
		//setBannerHT();
	});
	/**********************************************************************************/
	/*****************A N I M A T I O N********************/
	/**********************************************************************************/

	var tlSplash = gsap.timeline();
	//gsap.set('#splash_sceen', {opacity: 0});
	gsap.set('#splash_sceen .tag_line span', { display: 'inline-block', opacity: 0, y: 130, rotate: 20 });
	gsap.set('#splash_sceen .click_here', { opacity: 0, y: 40 });
	gsap.set('#splash_sceen .splash_data', { display: 'block' });

	tlSplash.to('#splash_sceen', { duration: 0, opacity: 1, ease: "sign.inOut" }, 'lblSplashScr')
		.to('#splash_sceen .tag_line span', { duration: 1, opacity: 1, y: 0, rotate: 0, ease: "power1.inOut", stagger: { amount: 0.2 } }, 'lblSplashScr-=0.1')
		.to('#splash_sceen .click_here', { duration: 0.6, opacity: 1, y: 0 }, 'lblSplashScr+=0.5')
		.set('.loading_screen', { display: 'block' })

	$('.splash_data .click_here').on('click', function () {
		var tl = gsap.timeline();
		tl.set('#splash_sceen', { display: 'block' })
			.to('body', {
				duration: 0, onComplete: function () {
					$('body').removeClass('overFlow');
				}
			})
			.to('.tag_line', { duration: 1, scale: 1.3, opacity: 0 }, 'closeSplashScr')
			.to('#splash_sceen .click_here', { duration: 1, opacity: 0 }, 'closeSplashScr')
			.to('#splash_sceen', { duration: 1, opacity: 0 }, 'closeSplashScr')
			.set('#splash_sceen', { display: 'none' })
			.to('.loading_screen', {
				duration: 0.6, opacity: 1, onComplete: function () {
					if (winWT >= 1024) {
						tl.to('.loader_logo', {
							duration: 0.8, left: '8%', top: '30px', maxWidth: '7.8125vw', ease: Power1.easeInOut, onComplete: function () {
								tl.to('.loading_screen', { duration: 1, opacity: 0, ease: 'sine.inout' })
									.set('.loading_screen', { display: 'none' })
								//addLoderLogoInHead();
							}
						})
					} else {
						tl.to('.loader_logo', {
							duration: 0.8, left: '50%', top: '20px', marginLeft: '-50px', maxWidth: '100px', ease: Power1.easeInOut, onComplete: function () {
								tl.to('.loading_screen', { duration: 1, opacity: 0, ease: 'sine.inout' })
									.set('.loading_screen', { display: 'none' })
								//addLoderLogoInHead();
							}
						})
					}
				}
			}, '-=0.2')
	});

	function addLoderLogoInHead() {
		var tempLogoPlace = $('.loader_logo').remove();
		$('header').append(tempLogoPlace);
	}

	/* let tl_hmAbout = gsap.timeline();
	ScrollTrigger.create({
		animation: tl_hmAbout,
		trigger: '.hm_about',
		start: "top 60p%",
		//markers: true
	});
	tl_hmAbout.fromTo('.hm_about h2 span', { opacity: 0, y: 70, rotate: 10}, { duration: 0.8, opacity: 1, y: 0, rotate: 0, ease: "power1.inOut", stagger: { amount: 0.2 }})
	.fromTo('.hm_about .sect_tl', { opacity:0, y:50}, { duration:0.8, opacity:1, y:0, ease: "power1.inOut"}, '-=0.3')
	.fromTo('.hm_about .button', { opacity:0, y:30}, { duration:0.5, opacity:1, y:0, ease: "power1.inOut"})
	.fromTo('.hm_about .counter_blurb', { opacity:0, y:70}, { duration:0.5, opacity:1, y:0, stagger: { amount: 0.2 }, ease: "power1.inOut"}, '-=0.1')
	.fromTo('.hm_about .note', { opacity:0}, { duration:0.5, opacity:1, ease: "power1.inOut"}, '-=0.1')

	let tl_vidNBFC = gsap.timeline();
	ScrollTrigger.create({
		animation: tl_vidNBFC,
		trigger: '.vid_nbfc',
		start: "top 60p%",
		//markers: true
	});
	tl_vidNBFC.fromTo('.vid_nbfc h2 span', { opacity: 0, y: 70, rotate: 10}, { duration: 0.8, opacity: 1, y: 0, rotate: 0, ease: "power1.inOut", stagger: { amount: 0.2 }})
	.fromTo('.vid_nbfc .sect_tl', { opacity:0, y:50}, { duration:0.8, opacity:1, y:0, ease: "power1.inOut"}, '-=0.3')
	.fromTo('.vid_nbfc .bg_cover', { opacity: 0, height: '50%', y: 30 }, { duration: 0.5, opacity: 1, y: 0, height: '100%', ease: "power1.inOut"})
	.fromTo('.vid_nbfc .play_btn', { opacity: 0, scale: 0.8 }, { duration: 0.5, opacity: 1, y: 0, scale: 1, ease: "power1.inOut"}); */





});